import './redux';
import './preact';
import moment from 'moment';
window.moment = moment;



// WEBPACK FOOTER //
// ./app/index.js